<h5 class="title mb-4 text-primary">{{'sessao_vi'|translate}}</h5>
<div class="row g-4 mb-4">
    <div class="col-lg-12">       
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_40')}}<span class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select class="form-select" #mdc_40="ngModel" name="mdc_40" [(ngModel)]="mdcService.formData.mdc_40"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc40options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
</div>